import React from 'react';
import { Modal, Form, Button } from 'react-bootstrap';

interface TodoFilterModalProps {
    show: boolean;
    onHide: () => void;
    showCompleted: boolean;
    onShowCompletedChange: (show: boolean) => void;
    completedCount: number;
}

const TodoFilterModal: React.FC<TodoFilterModalProps> = ({
    show,
    onHide,
    showCompleted,
    onShowCompletedChange,
    completedCount
}) => {
    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Filter</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group>
                        <Form.Check
                            type="switch"
                            id="show-completed-modal"
                            label={`Visa klara uppgifter (${completedCount})`}
                            checked={showCompleted}
                            onChange={(e) => onShowCompletedChange(e.target.checked)}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Stäng
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default TodoFilterModal;
